import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import DateInputMask from './DateInputMask.js';
import DateTimeInputMask from './DateTimeInputMask.js';
import DictionaryInputMask from './DictionaryInputMask.js';
import NumberInputMask from './NumberInputMask.js';
import PhoneInputMask from './PhoneInputMask.js';
import PhoneInternationalInputMask from './PhoneInternationalInputMask.js';
import SsnInputMask from './SsnInputMask.js';
import UsZipCodeInputMask from './UsZipCodeInputMask.js';
import ZipCodeSearchInputMask from './ZipCodeSearchInputMask.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'react-desc';
import '../../TextBox/DSTextBox.js';
import '../../Input/DSInput.js';
import '../../Input/InputImpl.js';
import '@babel/runtime/helpers/esm/typeof';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import 'prop-types';
import 'lodash';
import '@elliemae/ds-classnames';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-button';
import '@elliemae/ds-tooltip';
import '../../Input/InputAddonWrapper.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '../../Input/showEllipsis.js';
import '../utils/setCaretPosition.js';

var dollarSign = '$';
var percentSign = '%';
var emptyString = '';
var comma = ',';
var period = '.';
var OutOfTheBoxMaskTypes = {
  'ds-mask-date': function dsMaskDate(props) {
    return /*#__PURE__*/React.createElement(DateInputMask, props);
  },
  'ds-mask-date-time': function dsMaskDateTime(props) {
    return /*#__PURE__*/React.createElement(DateTimeInputMask, props);
  },
  'ds-mask-dictionary': function dsMaskDictionary(_ref) {
    var _ref$ignoreCase = _ref.ignoreCase,
        ignoreCase = _ref$ignoreCase === void 0 ? true : _ref$ignoreCase,
        rest = _objectWithoutProperties(_ref, ["ignoreCase"]);

    return /*#__PURE__*/React.createElement(DictionaryInputMask, _extends({
      ignoreCase: ignoreCase
    }, rest));
  },
  'ds-mask-number': function dsMaskNumber(_ref2) {
    var _ref2$prefix = _ref2.prefix,
        prefix = _ref2$prefix === void 0 ? dollarSign : _ref2$prefix,
        _ref2$suffix = _ref2.suffix,
        suffix = _ref2$suffix === void 0 ? emptyString : _ref2$suffix,
        _ref2$includeThousand = _ref2.includeThousandsSeparator,
        includeThousandsSeparator = _ref2$includeThousand === void 0 ? true : _ref2$includeThousand,
        _ref2$thousandsSepara = _ref2.thousandsSeparatorSymbol,
        thousandsSeparatorSymbol = _ref2$thousandsSepara === void 0 ? comma : _ref2$thousandsSepara,
        _ref2$allowDecimal = _ref2.allowDecimal,
        allowDecimal = _ref2$allowDecimal === void 0 ? false : _ref2$allowDecimal,
        _ref2$decimalSymbol = _ref2.decimalSymbol,
        decimalSymbol = _ref2$decimalSymbol === void 0 ? period : _ref2$decimalSymbol,
        _ref2$decimalLimit = _ref2.decimalLimit,
        decimalLimit = _ref2$decimalLimit === void 0 ? 2 : _ref2$decimalLimit,
        _ref2$requireDecimal = _ref2.requireDecimal,
        requireDecimal = _ref2$requireDecimal === void 0 ? false : _ref2$requireDecimal,
        _ref2$allowNegative = _ref2.allowNegative,
        allowNegative = _ref2$allowNegative === void 0 ? false : _ref2$allowNegative,
        _ref2$allowLeadingZer = _ref2.allowLeadingZeroes,
        allowLeadingZeroes = _ref2$allowLeadingZer === void 0 ? false : _ref2$allowLeadingZer,
        _ref2$integerLimit = _ref2.integerLimit,
        integerLimit = _ref2$integerLimit === void 0 ? null : _ref2$integerLimit,
        rest = _objectWithoutProperties(_ref2, ["prefix", "suffix", "includeThousandsSeparator", "thousandsSeparatorSymbol", "allowDecimal", "decimalSymbol", "decimalLimit", "requireDecimal", "allowNegative", "allowLeadingZeroes", "integerLimit"]);

    return /*#__PURE__*/React.createElement(NumberInputMask, _extends({
      prefix: prefix,
      suffix: suffix,
      includeThousandsSeparator: includeThousandsSeparator,
      thousandsSeparatorSymbol: thousandsSeparatorSymbol,
      allowDecimal: allowDecimal,
      decimalSymbol: decimalSymbol,
      decimalLimit: decimalLimit,
      requireDecimal: requireDecimal,
      allowNegative: allowNegative,
      allowLeadingZeroes: allowLeadingZeroes,
      integerLimit: integerLimit
    }, rest));
  },
  'ds-mask-percent': function dsMaskPercent(_ref3) {
    var _ref3$prefix = _ref3.prefix,
        prefix = _ref3$prefix === void 0 ? emptyString : _ref3$prefix,
        _ref3$suffix = _ref3.suffix,
        suffix = _ref3$suffix === void 0 ? percentSign : _ref3$suffix,
        _ref3$includeThousand = _ref3.includeThousandsSeparator,
        includeThousandsSeparator = _ref3$includeThousand === void 0 ? true : _ref3$includeThousand,
        _ref3$thousandsSepara = _ref3.thousandsSeparatorSymbol,
        thousandsSeparatorSymbol = _ref3$thousandsSepara === void 0 ? comma : _ref3$thousandsSepara,
        _ref3$allowDecimal = _ref3.allowDecimal,
        allowDecimal = _ref3$allowDecimal === void 0 ? false : _ref3$allowDecimal,
        _ref3$decimalSymbol = _ref3.decimalSymbol,
        decimalSymbol = _ref3$decimalSymbol === void 0 ? period : _ref3$decimalSymbol,
        _ref3$decimalLimit = _ref3.decimalLimit,
        decimalLimit = _ref3$decimalLimit === void 0 ? 2 : _ref3$decimalLimit,
        _ref3$requireDecimal = _ref3.requireDecimal,
        requireDecimal = _ref3$requireDecimal === void 0 ? false : _ref3$requireDecimal,
        _ref3$allowNegative = _ref3.allowNegative,
        allowNegative = _ref3$allowNegative === void 0 ? false : _ref3$allowNegative,
        _ref3$allowLeadingZer = _ref3.allowLeadingZeroes,
        allowLeadingZeroes = _ref3$allowLeadingZer === void 0 ? false : _ref3$allowLeadingZer,
        _ref3$integerLimit = _ref3.integerLimit,
        integerLimit = _ref3$integerLimit === void 0 ? null : _ref3$integerLimit,
        rest = _objectWithoutProperties(_ref3, ["prefix", "suffix", "includeThousandsSeparator", "thousandsSeparatorSymbol", "allowDecimal", "decimalSymbol", "decimalLimit", "requireDecimal", "allowNegative", "allowLeadingZeroes", "integerLimit"]);

    return /*#__PURE__*/React.createElement(NumberInputMask, _extends({
      prefix: prefix,
      suffix: suffix,
      includeThousandsSeparator: includeThousandsSeparator,
      thousandsSeparatorSymbol: thousandsSeparatorSymbol,
      allowDecimal: allowDecimal,
      decimalSymbol: decimalSymbol,
      decimalLimit: decimalLimit,
      requireDecimal: requireDecimal,
      allowNegative: allowNegative,
      allowLeadingZeroes: allowLeadingZeroes,
      integerLimit: integerLimit
    }, rest));
  },
  'ds-mask-phone': function dsMaskPhone(props) {
    return /*#__PURE__*/React.createElement(PhoneInputMask, props);
  },
  'ds-mask-phone-international': function dsMaskPhoneInternational(props) {
    return /*#__PURE__*/React.createElement(PhoneInternationalInputMask, props);
  },
  'ds-mask-ssn': function dsMaskSsn(props) {
    return /*#__PURE__*/React.createElement(SsnInputMask, props);
  },
  'ds-mask-us-zip-code': function dsMaskUsZipCode(props) {
    return /*#__PURE__*/React.createElement(UsZipCodeInputMask, props);
  },
  'ds-mask-zip-code-search': function dsMaskZipCodeSearch(props) {
    return /*#__PURE__*/React.createElement(ZipCodeSearchInputMask, props);
  }
};

export { OutOfTheBoxMaskTypes };
//# sourceMappingURL=index.js.map
